<template>
  <div class="companySyn">
    <bread :list="list"></bread>
    <el-form :label-position="labelPosition" :model="formLabelAlign" class="companySyn">
      <el-form-item label="关于我们:" size="large" class="comSyn text-center margin-top-50">
        <div class="bianji" v-if="about_us_type==2">
          <input
            type="file"
            @change="update"
            accept=".jpg, .jpeg, .png, .JPG, .JPEG, .PBG"
            ref="contentUpload"
            id="avatar-uploader"
          />
          <i class="iconfont icon-htmal5icon12"></i>
        </div>
        <quill-editor
          v-if="about_us_type==1"
          v-model="formLabelAlign.profile"
          ref="content"
          class="quill"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        ></quill-editor>
        <quill-editor
          v-model="formLabelAlign.profile"
          v-if="about_us_type==2"
          ref="content"
          class="quill"
          :options="editorOption1"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        ></quill-editor>
      </el-form-item>
      <el-form-item size="large" class="frombutton text-center margin-top-50">
        <el-button class="btn1" type="primary" @click="onSubmit">确认</el-button>
        <el-button class="btn2" @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Quill from "quill";
let Parchment = Quill.import("parchment");
console.log(Parchment);
import bread from "../../../components/bread";
const toolbarOptions = [
  ["bold", "italic"], //加粗，斜体，
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ color: [] }], // 字体颜色，字体背景颜色
  [{ align: [] }] //对齐方式
  // ['image']   // 链接、图片、视频
];
const toolbarOptions1 = [
  ["bold", "italic"], //加粗，斜体，
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ color: [] }], // 字体颜色，字体背景颜色
  [{ align: [] }], //对齐方式
  ["image"] // 链接、图片、视频
];
export default {
  components: {
    bread
  },
  data() {
    return {
      list: [
        {
          title: "信息管理"
        },
        {
          title: "关于我们"
        }
      ],
      labelPosition: "right",
      formLabelAlign: {
        token: window.localStorage.getItem("pc_token"),
        type: "",
        profile: ""
      },
      editorOption: {
        placeholder: "请输入",
        modules: {
          toolbar: toolbarOptions
        }
      }, // 富文本配置 文本编辑器
      editorOption1: {
        placeholder: "请输入",
        modules: {
          toolbar: toolbarOptions1
        }
      }, // 图文本配置
      about_us_type: "", //==1  无图编辑   ==2  有图编辑
      btnDis: true
    };
  },
  created() {
    this.companyProfile(1); //公司简介内容显示
  },
  methods: {
    update() {
      let inputDOM = this.$refs.contentUpload;
      this.file = inputDOM.files[0];
      console.log(this.file);
      let isJPG =
        this.file.type === "image/jpeg" || this.file.type === "image/png";
      let isLt1M = this.file.size / 1024 / 1024 < 0.1;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式!");
        return false;
      }
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 100k!");
        return false;
      }
      var formdata = new FormData();
      formdata.append(
        "file",
        document.getElementById("avatar-uploader").files[0]
      );
      formdata.append("type", 5);
      this.post(this, "/common/upload/image/qiniu", formdata).then(res => {
        this.imgUrl = res.data.url;
        let quill = this.$refs.content.quill;
        // const range = quill.getSelection();
        const range = quill.selection.savedRange;
        if (range) {
          quill.insertEmbed(range.index, "image", this.imgUrl);
        }
        // console.log(quill.selection.savedRange.index)
        // quill.setSelection(quill.getSelection().index + 1);
        quill.setSelection(quill.selection.savedRange.index + 1);
        this.$refs.contentUpload.value = null;
      });
    },
    companyProfile(type) {
      this.formLabelAlign.type = type;
      var profile = this.formLabelAlign.profile;
      if (type == 2) {
        if (!profile || profile.trim() == "") {
          this.$message.error("内容不能为空");
          this.isDisabled = true;
          return false;
        }
      }
      this.post(this, "/home/companyProfile", this.formLabelAlign).then(res => {
        if (res.data.code == 0) {
          this.btnDis = false;
        }
        if (res.data.code == 0) {
          if (type == 2) {
            this.$message.success(res.data.msg);
          } else {
            this.about_us_type = res.data.data.about_us_type; //==1  无图编辑   ==2  有图编辑
            if (res.data.data.enterprise_content != null) {
              this.formLabelAlign.profile = res.data.data.enterprise_content.replace(
                /(<\/?a.*?>)|(<\/?span.*?>)/g,
                ""
              );
            }
          }
        }
        this.isDisabled = true;
      });
    },
    // 确认
    onSubmit() {
      if (this.btnDis) {
        return false;
      }
      if (
        this.isDisabled &&
        document.getElementsByClassName("el-message").length === 0
      ) {
        this.isDisabled = false;
        this.companyProfile(2); //公司简介内容提交
      }
    },
    onEditorReady(editor) {
      // 准备编辑器
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange(e) {
      if (e.html.indexOf("&lt;a") >= 0 || e.html.indexOf("<a") >= 0) {
        this.formLabelAlign.profile = this.formLabelAlign.profile.replace(
          /(<\/?a.*?>)|(<\/?span.*?>)/g,
          ""
        );
      }
    } // 内容改变事件
  },
  computed: {
    editor() {
      return this.$refs.content.quill;
    }
  }
};
</script>
<style>
.comSyn {
  display: flex;
}
.comSyn .el-form-item__content {
  width: 65%;
}
.comSyn .el-form-item__content::after {
  content: "提示：有图编辑权限下上传图片建议最大为100k";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(105%);
  color: #606266;
  font-size: 14px;
  line-height: 40px;
}
#avatar-uploader {
  position: relative;
  z-index: 3;
  opacity: 0;
  width: 18px;
}
.icon-htmal5icon12 {
  position: absolute;
  left: 0;
  z-index: 2;
  font-size: 18px;
}
.bianji {
  position: absolute;
  left: 282px;
  transform: translateY(50%);
}
</style>
<style scoped>
.frombutton {
  width: 100%;
  margin-left: 73px;
  margin-right: 20px;
}
.quill-editor {
  min-width: 450px !important;
}
.btn1,
.btn2 {
  width: 130px;
  border: none;
}
.btn1 {
  background-color: #ff7c00;
  color: #fff;
  margin-right: 30px;
}
.btn2 {
  background-color: #d2d2d2;
  color: #fff;
}
</style>

<style>
.companySyn .ql-image {
  display: none !important;
}
</style>